import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';
import { storeActivePage } from 'models/common';
import { initializeInquire } from 'models/inquire';
import ResultRoute from './Result';

const routes: CustomRoute = {
	path: '/inquire',
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'inquire' */ './component')],
			render: ([Inquire]) => <Inquire />,
			onEnter: async ({ store, next }) => {
				console.log('on Enter Inquire');
				const children = await next();
				store.dispatch(initializeInquire());
				store.dispatch(storeActivePage('inquire'));
				console.log('on Enter Inquire / end');
				return children;
			},
		},
		ResultRoute,
	],
};

export default routes;
